import {dataLayerService} from "./dataLayer.js";
import { TrackingEventDataLookup } from "./trackingEventDataLookup.js";
import {EventType, TrackingKey} from "./tracking.js";

export type TrackingEvent = {
    eventType: EventType,
    trackingKey: TrackingKey,
}

export class TrackingService {
    private readonly eventDataLookup: TrackingEventDataLookup;

    constructor() {
        this.eventDataLookup = new TrackingEventDataLookup();
    }

    public trackEvent(event: TrackingEvent) {
        const eventData = this.eventDataLookup.find(event);
        if (! eventData) {
            return;
        }

        const promise = new Promise<void>(resolve => {
            eventData.eventCallback = () => {
                resolve();
            };
        });

        dataLayerService.push(eventData);

        return promise;
    }
}


export const trackingService = new TrackingService();
